import React from 'react';
import { Poppins } from 'src/common';
import styled from 'styled-components';
import { isNil } from 'lodash';
import { formatNumber } from 'src/utils/misc';
import { useStateSelector } from 'src/redux/store';

const Div = styled.div`
  border: 1px dashed ${({ theme }) => theme.colors.cflowerBlue};
  border-radius: 6px;
  padding: 9px 12px;
`;

const Indicators = styled.div<{ $color: string }>`
  display: inline-block;
  height: 12px;
  width: 12px !important;
  background-color: ${({ $color }) => $color};
  border-radius: 6px;
  margin-right: 4px;
`;

interface ConsequenceRangeIndicatorProps {
  lowerResult?: number;
  upperResult?: number;
}

export const ConsequenceRangeIndicator: React.FC<ConsequenceRangeIndicatorProps> = ({ lowerResult, upperResult }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  if (isNil(lowerResult) || isNil(upperResult)) return null;

  const difference = upperResult - lowerResult;

  let message = '';
  let indicatorColor = '';

  if (difference <= 15000000) {
    message = 'This range represents a good level of uncertainty for the consequence of a risk.';
    indicatorColor = colors.statusGreen;
  } else if (difference <= 25000000) {
    message = 'This range represents a reasonable level of uncertainty for the consequence of a risk.';
    indicatorColor = colors.statusAmber;
  } else {
    message =
      'This range represents a high level of uncertainty for the consequence of a risk and may lead to statistical anomalies. Consider splitting this risk into multiple risks.';
    indicatorColor = colors.statusRed;
  }

  return (
    <>
      <Div>
        <Poppins px={14} weight={500}>
          9 times out of 10, the consequence will be between {formatNumber(lowerResult, { symbol: true })} and{' '}
          {formatNumber(upperResult, { symbol: true })}.
        </Poppins>
        <div>
          <Poppins px={14}>
            <Indicators $color={indicatorColor} />
            <i>{message}</i>
          </Poppins>
        </div>
      </Div>
    </>
  );
};
